<template>
	<div class="relative w-full">
		<!-- Timeline markers and headlines skeleton -->
		<div class="relative z-10 pt-2 overflow-x-hidden h-[124px] lg:h-[132px]">
			<!-- Timeline line skeleton -->
			<span
				class="w-full h-1 absolute left-0 top-[4px]"
				:class="[
					alternative ? 'bg-white/[.1]' : 'bg-slate-300/[0.1]',
					staticMode ? '' : 'animate-pulse'
				]"
			/>

			<!-- Slideshow items skeleton -->
			<div class="flex absolute left-0 top-0 h-full">
				<div
					v-for="n in itemCount"
					:key="'skeleton-' + n"
					class="flex flex-col items-start relative flex-shrink-0"
					:style="{
						'min-width': `${itemWidth}px`,
						'max-width': `${itemWidth}px`
					}"
				>
					<!-- Timeline marker skeleton -->
					<div class="relative w-full h-3 flex items-center mb-2">
						<span
							class="w-full h-1"
							:class="[
								alternative ? 'bg-white/[.1]' : 'bg-slate-300/[0.1]',
								staticMode ? '' : 'animate-pulse'
							]"
						></span>
						<span
							class="absolute top-0 bottom-0 left-0 w-[12px] h-[12px] bg-slate-300/[0.1] rounded-full"
							:class="staticMode ? '' : 'animate-pulse'"
						></span>
					</div>

					<!-- Headline skeleton -->
					<div class="w-full pr-4 mb-2">
						<div
							class="h-5 rounded mb-2"
							:class="[
								alternative ? 'bg-white/[.1]' : 'bg-slate-300/[0.1]',
								staticMode ? '' : 'animate-pulse'
							]"
						></div>
						<div
							class="h-5 rounded mb-2 w-4/5"
							:class="[
								alternative ? 'bg-white/[.1]' : 'bg-slate-300/[0.1]',
								staticMode ? '' : 'animate-pulse'
							]"
						></div>
						<div
							class="h-5 rounded w-3/5"
							:class="[
								alternative ? 'bg-white/[.1]' : 'bg-slate-300/[0.1]',
								staticMode ? '' : 'animate-pulse'
							]"
						></div>
					</div>

					<!-- Time skeleton -->
					<div
						class="h-4 rounded w-20"
						:class="[
							alternative ? 'bg-white/[.1]' : 'bg-slate-300/[0.1]',
							staticMode ? '' : 'animate-pulse'
						]"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
interface Props {
	itemCount?: number;
	itemWidth?: number;
	shouldShowOverlay?: boolean;
	alternative?: boolean;
	staticMode?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	itemCount: 5,
	itemWidth: 280,
	shouldShowOverlay: false,
	alternative: false,
	staticMode: false
});
</script>

<style scoped>
.coverage-row-overlay {
	position: absolute;
	top: 0;
	right: 0;
	width: 100px;
	height: 100%;
	background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.8));
	pointer-events: none;
	z-index: 10;
}

.coverage-row-overlay.alternative {
	background: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.8));
}

/* Custom pulse animation for better skeleton effect */
@keyframes pulse {
	0%,
	100% {
		opacity: 0.4;
	}
	50% {
		opacity: 0.8;
	}
}

.animate-pulse {
	animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
